// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Extract-ExtractForm-module__item";
export { _1 as "item" }
